export const SET_MONTH_RESULT = "SET_MONTH_RESULT";

const _setMonth = (status, data, err) => {
  return {
    type: SET_MONTH_RESULT,
    data,
    err,
    status
  };
};

const setMonth = (monthId, data) => {
  return (dispatch, getState, Request) => {
    return Promise.resolve(
      dispatch(
        _setMonth(
          `Adding Month ${monthId}`,
          {
            monthId: parseInt(monthId, 0),
            data: data
          },
          null
        )
      )
    );
  };
};

class OpsManagerAction {
  static setMonth = setMonth;
}

export default OpsManagerAction;



// WEBPACK FOOTER //
// ./src/app/simulation/redux/OpsManager.action.react.js